<template>
  <div class="toolbar">
    <div style="width: 319px;display: flex;align-items: center">
      <div class="name" style="min-width: 60px">
        名称：
      </div>
      <div  v-show="nameFlag" class="name" style="max-width: 196px">
        {{form.sceneName}}
      </div>
    </div>
    <div style="margin-right: 2%;cursor: pointer;margin-left: 50%;display: flex;">
      <img src="@/assets/img/editor/start.png" alt="" width="24" height="24" @click="run">
      <span style="margin: auto 20px auto auto;font-size: 16px; min-width: 35px;" @click="run">运行</span>
    </div>
    <div style="width: 200px;display: flex;align-items: center">
      <div style="padding-right: 50px">
      <el-button
          style="border-radius: 20px;font-size: 14px;color: #4D78FF;border-color: #4D78FF;width: 90px;box-sizing: border-box;"
          size="small "
      >{{typeName}}</el-button>
      </div>
      <i class="el-icon-close" style="margin: auto;color: #999999;font-size: 26px;cursor: pointer;float: right" @click="leave"></i>
    </div>
  </div>
</template>

<script>
import eventBus from '@/utils/eventBus'
import car_done from '@/assets/img/editor/done/car_done.png'
import release_done from '@/assets/img/editor/done/release_done.png'
import work_done from '@/assets/img/editor/done/work_done.png'
import car_wait from '@/assets/img/editor/wait/car_wait.png'
import release_wait from '@/assets/img/editor/wait/release_wait.png'
import car_work from '@/assets/img/editor/work/car_work.png'
import work_work from '@/assets/img/editor/work/work_work.png'
import { getSceneTotal, selectScene, makeOperationStr } from '@/api/modules/beginner'
export default {
  data() {
    return {
      page: {},
      graph: {},
      editor: null,
      command: null,
      selectedItem: null,
      multiSelect: false,
      addGroup: false,
      sceneId: this.$route.query.id,
      textarea: '',
      centerDialogVisible: false,
      dialogVisible: false,
      fileList: [],
      dialogImageUrl: '',
      uploadDialogVisible: false,
      keyword: '',
      workType: 1,
      testFlag: false,
      nameFlag: true,
      btnFlag: false,
      drawer: false,
      disabled: false,
      // form: { sceneStatus: 1 },
      form: {
        id: null,
        catalogueId: this.$route.query.catalogueId,
        sceneName: '',
        sceneDesc: '',
        logoUrl: '',
        logoKey: '',
        sceneStatus: 0,
        nodeDetailParams: '{"nodes":[{"id":"node_1","type":"start-node","x":750,"y":100,"text":"开始"}]}'
      },
      testInfo: {},
      lf: null
    }
  },
  computed: {
    typeName() {
      if (this.btnFlag) {
        return '变更'
      }
      if (this.form.sceneStatus === 1) {
        return '车辆测试'
      }
      else if (this.form.sceneStatus === 2) {
        return '发布'
      }
      else {
        return '开发中'
      }
    },
    img1() {
      if (this.form && Number(this.form.sceneStatus) === 0) {
        return work_work
      }
      return work_done
    },
    img2() {
      if (this.form && Number(this.form.sceneStatus) === 1) {
        return car_work
      }
      if (this.form && Number(this.form.sceneStatus) > 1) {
        return car_done
      }
      return car_wait
    },
    img3() {
      if (this.form && Number(this.form.sceneStatus) === 2) {
        return release_done
      }
      return release_wait
    }
  },
  watch: {
    selectedItem(val) {
      if (val && val.length > 1) {
        this.addGroup = true
      }
      else {
        this.addGroup = false
      }
    },
    keyword(val) {
      eventBus.$emit('keyword', val)
    }
  },
  created() {
    // this.init()
    if (this.sceneId !== '' && this.sceneId !== null && this.sceneId !== undefined) {
      this.selectScene()
    }
    else {
      this.getSceneTotal()
      this.$nextTick(() => {
        eventBus.$emit('loadNode', this.form.nodeDetailParams)
      })
    }
    eventBus.$on('loadNodeReturn', (lf) => {
      // console.log(JSON.parse(param), 666)
      this.lf = lf
    })
  },
  methods: {
    async selectScene() {
      const data = { id: this.sceneId }
      const res = await selectScene(data)
      this.form = res.data
      if (res.data.logoUrl !== '' && res.data.logoUrl !== null) {
        this.fileList = [{ name: res.data.logoUrl, url: res.data.logoUrl }]
      }
      this.$nextTick(() => {
        eventBus.$emit('loadNode', this.form.nodeDetailParams)
      })
      console.log('res', res)
    },
    async getSceneTotal() {
      const res = await getSceneTotal({})
      if (res.code === 0) {
        this.form.sceneName = '您的第' + res.data + '个场景'
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    async run() {
      const makeData = this.lf.getGraphData()
      console.log(makeData)
      const res = await makeOperationStr(makeData)
      if (res.code === 0) {
        this.$emit('handleClick', res.data)
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    leave() {
      this.$router.go(-1)
      this.$message({
        type: 'success',
        message: '退出成功'
      })
    }
  }
}
</script>

<style scoped>
.toolbar {
  background-color: #fff;
  display: flex;
  box-sizing: border-box;
  padding: 12px 10px 13px 20px;
  width: 100%;
  border-bottom: 1px solid #DDDDDD;
  height: 61px;
  z-index: 3;
  /*box-shadow: 0px 8px 12px 0px rgba(0, 52, 107, 0.04);*/
  position: absolute;
  align-items:center;
  justify-content:space-between;
}
.toolbar .command:nth-of-type(1) {
  margin-left: 24px;
}
.toolbar .command {
  font-size: 24px;
  /*box-sizing: border-box;*/
  width: 27px;
  height: 27px;
  /*margin: 0px 6px;*/
  /*border-radius: 2px;*/
  padding-left: 6px;
  /*display: inline-block;*/
  /*border: 1px solid rgba(2, 2, 2, 0);*/
}
.toolbar .command:hover {
  cursor: pointer;
  /*font-size: 28px;*/
  /*border: 1px solid #e9e9e9;*/
}
.toolbar .name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 18px;
  font-weight: 400;
  color: #2F374B;
  line-height: 46px;
  letter-spacing: 2px;
  box-sizing: border-box;
}
.toolbar .disable {
  color: rgba(0, 0, 0, 0.25);
}
.toolbar .name_input {

}
/deep/.el-input__inner {
  border-radius: 20px;
  border: 1px solid #4D78FF;
}
/deep/#name{
  border-radius: 4px !important;
}
/deep/.el-dialog__title{
  font-size: 14px;
  font-weight: bold;
}
/deep/.el-dialog__header{
  padding: 40px 20px 0;
}
/deep/.el-dialog__footer{
  padding: 50px 20px 40px;
}
.onWork_line{
  border:2px solid #4D78FF;
}
.line{
  border:2px solid #DDDDDD;
}
.onInit{
  border: 5px solid #B8C9FF;
}
.onOver{
  border: 5px solid #4D78FF;
}
.onWork{
  border: 5px solid #49A37D;
}
/*/deep/.el-input.is-disabled .el-input__inner{*/
/*  border: unset;*/
/*  color: #2F374B;*/
/*  background-color: unset;*/
/*  width: auto;*/
/*}*/
.waitStatus{
  background-color: #F5F6F8;
  border: 1px solid #DDDDDD;
  color:#A7A7A7;
  border-radius: 12.5px;
  padding: 4px 0;
  width: 80%;
  margin: auto
}
.status{
  background-color: #EDFFEE;
  border: 1px solid #09D589;
  color:#09D589;
  border-radius: 12.5px;
  padding: 4px 0;
  width: 80%;
  margin: auto
}
</style>
